
import { getAggregateError, } from "@bracket/catch";
import { getVaultLockTime,} from "@bracket/parlance";
import type { CombinedDataStoreState, IdentifiableVaultWithState, } from "@types";
import { getLoadedVault,} from "@vault/resolvers/loaded";
import type { DateTime, } from "luxon";


/**
 * Calculates the start date of the next epoch for a vault based on its launch date and current epoch.
 * 
 * @param {IdentifiableVault} vault - The vault to calculate the next epoch start date for
 * @returns {Promise<DateTime | "UNKNOWN">} The DateTime of the next epoch start or "UNKNOWN" if vault is not active
 * @throws {Error} If the vault cannot be loaded
 */
export const getNextEpochStartDate = async ( store: CombinedDataStoreState, vault:IdentifiableVaultWithState ): Promise<DateTime | "UNKNOWN"> => {

	try {
		const loaded = await getLoadedVault(store, vault);
		const { epoch, status, } = loaded;
		if(epoch < 1 || status !== "ACTIVE") {
			return "UNKNOWN";
		}
		return getVaultLockTime({ vault: loaded, epoch, local: true, });
	}
	catch(error) {
		throw getAggregateError(error, `failed getting next epoch start date for vault ${vault.symbol} ${vault.address}`);
	}
}
